export const fromVali = (name:String, name1:String) =>{
    if (!name || name.length <= 0) {
      return 'Select FROM airport';
    }
    if(name === name1){
      return 'Origin and Destination cannot be same. ';
    }
    return '';
}

export const toVali = (name:String, name1:String) =>{
    if (!name || name.length <= 0) {
      return 'Select TO airport';
    }
    if(name === name1){
      return 'Origin and Destination cannot be same.';
    }
    return '';
}

export const depVali = (name:String) =>{

    if (!name || name.length <= 0) {
      return 'Select DEPATURE date';
    }
    return '';
  }

export const retVali = (name:String) =>{
    if (!name || name.length <= 0) {
      return 'Select RETURN date';
    }
    return '';
}